<h1 style="text-align: center;">Estado</h1>
    <body>
        <app-report-total-proposals></app-report-total-proposals>
        <app-report-total-voters></app-report-total-voters>
        <div id="div1">
            <app-report-proposal-categories></app-report-proposal-categories>
        </div>
        <div id="div2">
            <app-report-track-voters ></app-report-track-voters>
        </div>
    </body>


